import * as React from 'react';

import { singleton } from 'logic/singleton';
import type { HandlerContext as HandlerContextType } from 'views/types';

const HandlerContext = React.createContext<HandlerContextType | undefined>(undefined);

export default singleton('contexts.SearchFiltersHandlerContext', () => HandlerContext);
